(function ($) {
   $(function () {
      // get the height of the header and store it in a variable
      function updateHeaderHeight() {
         var totalHeight = $('header').outerHeight();
         // set the height in a css variable
        //  if (window.innerWidth < 1350 && window.innerWidth > 782) {
        //     totalHeight += $('.menu-container > nav').outerHeight();
        //  }
         document.documentElement.style.setProperty(
            '--header-height',
            totalHeight + 'px',
         );
      }

      // Initial calculation
      updateHeaderHeight();

      // Recalculate on window resize
      $(window).on('resize', function () {
         updateHeaderHeight();
      });
      $('.open-menu').on('click', function () {
         $(this).toggleClass('open');
         $('.menu-container').toggleClass('open');
         var headerHeight = $('header').outerHeight();
         if ($('.menu-container').hasClass('open')) {
            $('.menu-container').css('top', headerHeight);
         } else {
            $('.menu-container').css('top', '');
         }
      });
      $('.booking-container summary').on('click', function () {
         console.log($(this).closest('.booking-content-wrapper'));
         $(this)
            .closest('.booking-content-wrapper')
            .css('min-height', $('.booking-content-wrapper').outerHeight());
      });
      // close the menu when clicking outside of it
      $(document).on('click', function (event) {
         if (!$(event.target).closest('.booking-container').length) {
            $('.booking-container').removeAttr('open');
         }
      });
   });
})(jQuery);
